module.exports = __webpack_public_path__ + "img/play.9e668471.svg";